// Bank Config 银行配置相关翻译
export default {
  // Page Title
  'pages.bank-config.title': 'Bank Configuration',
  'pages.bank-config.subtitle': 'Bank Account Configuration Management',

  // Table Columns
  'pages.bank-config.table.columns.bankName': 'Bank Name',
  'pages.bank-config.table.columns.accountName': 'Account Name',
  'pages.bank-config.table.columns.accountNumber': 'Account Number',
  'pages.bank-config.table.columns.status': 'Status',
  'pages.bank-config.table.columns.createTime': 'Create Time',
  'pages.bank-config.table.columns.operations': 'Operations',

  // Action Buttons
  'pages.bank-config.table.actions.view': 'View',
  'pages.bank-config.table.actions.edit': 'Edit',
  'pages.bank-config.table.actions.delete': 'Delete',
  'pages.bank-config.table.actions.add': 'Add',

  // Form Fields
  'pages.bank-config.form.fields.bankName': 'Bank Name',
  'pages.bank-config.form.fields.accountName': 'Account Name',
  'pages.bank-config.form.fields.accountNumber': 'Account Number',
  'pages.bank-config.form.fields.status': 'Status',
  'pages.bank-config.form.fields.remark': 'Remark',

  // Form Placeholders
  'pages.bank-config.form.placeholder.bankName': 'Please enter bank name',
  'pages.bank-config.form.placeholder.accountName': 'Please enter account name',
  'pages.bank-config.form.placeholder.accountNumber':
    'Please enter account number',
  'pages.bank-config.form.placeholder.remark': 'Please enter remark',

  // Status
  'pages.bank-config.status.active': 'Active',
  'pages.bank-config.status.inactive': 'Inactive',

  // Messages
  'pages.bank-config.message.success': 'Operation successful',
  'pages.bank-config.message.error': 'Operation failed',
  'pages.bank-config.message.deleteConfirm':
    'Are you sure you want to delete this bank configuration?',

  // Compatible with bankConfig (camelCase) keys
  'pages.bankConfig.table.title': 'Bank Configuration',
  'pages.bankConfig.table.columns.name': 'Bank Name',
  'pages.bankConfig.table.columns.logo': 'Logo',
  'pages.bankConfig.table.columns.description': 'Description',
  'pages.bankConfig.table.columns.sort': 'Sort',
  'pages.bankConfig.table.columns.operations': 'Operations',
  'pages.bankConfig.actions.add': 'Add',
  'pages.bankConfig.actions.edit': 'Edit',
  'pages.bankConfig.actions.delete': 'Delete',
  'pages.bankConfig.confirm.deleteTitle': 'Delete Confirmation',
  'pages.bankConfig.confirm.deleteContent':
    'Are you sure you want to delete bank "{name}"?',
  'pages.bankConfig.form.createTitle': 'Add Bank',
  'pages.bankConfig.form.editTitle': 'Edit Bank',
  'pages.bankConfig.form.nameLabel': 'Bank Name',
  'pages.bankConfig.form.nameRequired': 'Please enter bank name',
  'pages.bankConfig.form.nameMaxLength':
    'Bank name cannot exceed 100 characters',
  'pages.bankConfig.form.namePlaceholder': 'Please enter bank name',
  'pages.bankConfig.form.logoLabel': 'Bank Logo',
  'pages.bankConfig.form.logoRequired': 'Please upload bank logo',
  'pages.bankConfig.form.logoTooltip':
    'Supports jpg/png/webp and other image formats',
  'pages.bankConfig.form.logoUploadText': 'Click to Upload',
  'pages.bankConfig.form.logoUploading': 'Uploading...',
  'pages.bankConfig.form.sortLabel': 'Sort',
  'pages.bankConfig.form.sortPlaceholder': 'Please enter sort value',
  'pages.bankConfig.form.descriptionLabel': 'Description',
  'pages.bankConfig.form.descriptionMaxLength':
    'Description cannot exceed 500 characters',
  'pages.bankConfig.form.descriptionPlaceholder': 'Please enter description',
  'pages.bankConfig.message.fetchViewUrlFailed':
    'Failed to get preview URL configuration',
  'pages.bankConfig.message.fetchParentIdFailed':
    'Failed to get parent dictionary',
  'pages.bankConfig.message.fetchSortFailed': 'Failed to get sort value',
  'pages.bankConfig.message.uploadSuccess': 'Upload successful',
  'pages.bankConfig.message.uploadFailed': 'Upload failed',
  'pages.bankConfig.message.systemError':
    'System error, please try again later',
  'pages.bankConfig.message.createSuccess': 'Created successfully',
  'pages.bankConfig.message.createFailed': 'Creation failed',
  'pages.bankConfig.message.updateSuccess': 'Updated successfully',
  'pages.bankConfig.message.updateFailed': 'Update failed',
  'pages.bankConfig.message.deleteSuccess': 'Deleted successfully',
  'pages.bankConfig.message.deleteFailed': 'Deletion failed',
};
